export enum NotificationVisibility
{
    Visible,
    Hidden,
}
